import { pick } from 'lodash'
import { page, track } from '../analytics'

const getArgs = args => {
  return pick(args, ['workspaceId', 'workspaceSlug', 'traitId', 'traitName'])
}

export const personasTraitsCatalogViewed = args => {
  page(
    'Personas Traits Catalog Viewed',
    pick(args, ['workspaceId', 'workspaceSlug'])
  )
}

export const personasTraitCreated = args => {
  track('Personas Trait Created', {
    ...getArgs(args),
    ...pick(args, ['destinations', 'destinationCount', 'traitType'])
  })
}

export const personasTraitUpdated = args => {
  track('Personas Trait Updated', {
    ...getArgs(args),
    traitType: args.traitType
  })
}

export const personasTraitDisabled = args => {
  track('Personas Trait Disabled', getArgs(args))
}

export const personasTraitDeleted = args => {
  track('Personas Trait Deleted', {
    ...getArgs(args),
    traitType: args.traitType
  })
}

export const personasTraitPreviewClicked = args => {
  track('Personas Trait Preview Clicked', getArgs(args))
}

export const personasTraitPreviewSucceeded = args => {
  const trackArgs = pick(args, [
    'workspaceId',
    'workspaceSlug',
    'astDefinition',
    'runId'
  ])

  if (args.traitId) {
    Object.assign(trackArgs, pick(args, 'traitId'))
  }

  if (args.traitName) {
    Object.assign(trackArgs, pick(args, 'traitName'))
  }

  track('Personas Trait Preview Succeeded', trackArgs)
}

export const personasTraitPreviewFailed = args => {
  const trackArgs = pick(args, [
    'workspaceId',
    'workspaceSlug',
    'astDefinition'
  ])

  if (args.traitId) {
    Object.assign(trackArgs, pick(args, 'traitId'))
  }

  if (args.traitName) {
    Object.assign(trackArgs, pick(args, 'traitName'))
  }

  if (args.errorMessage) {
    Object.assign(trackArgs, pick(args, 'errorMessage'))
  }

  if (args.runId) {
    Object.assign(trackArgs, pick(args, 'runId'))
  }

  track('Personas Trait Preview Failed', trackArgs)
}

export const personasTraitDestinationsAdded = args => {
  track('Personas Trait Destination Added', {
    ...getArgs(args),
    ...pick(args, ['destinations', 'destinationCount'])
  })
}

export const personasTraitDestinationUpdated = args => {
  track('Personas Trait Destination Updated', {
    ...getArgs(args),
    ...pick(args, ['type', 'destinationName'])
  })
}
